import { useState, type VoidFunctionComponent } from 'react';

import { BINARY_DECOMPOSITION } from '../../../../shared/featureFlags/flagNames';
import { PREMIUM_PER_REVISION_PLAN_NAME } from '../../../../shared/subscriptions';
import { useIsFeatureEnabled } from '../../../helpers/features';
import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';
import Flex from '../../generic/Flex';
import type { Organization, SetState } from '../../../types';

import BillingTermCard from './BillingTermCard';
import ChangeSubscriptionCard from './ChangeSubscriptionCard';
import ContributorCountCard from './CustomContribCountCard';
import ToggleInternalOrgCard from './ToggleInternalOrgCard/ToggleInternalOrgCard';

type Props = {
  org: Organization;
  setOrg: SetState<Organization>;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const BillingGroupCard: VoidFunctionComponent<Props> = ({ org, setOrg, isOpen, onToggle }) => {
  const [isSectionOpen, setIsSectionOpen] = useState(isOpen ?? false);
  const handleToggle = () => {
    setIsSectionOpen(!isSectionOpen);
    onToggle?.(isSectionOpen);
  };

  const hasBinaryDecomp = useIsFeatureEnabled(BINARY_DECOMPOSITION);

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="billing-and-subscriptions" isInitiallyOpen={isSectionOpen}>
          <Accordion.Target onClick={handleToggle}>Billing and Subscriptions</Accordion.Target>
          <Accordion.Body>
            <Flex direction="column" gap={12}>
              <ChangeSubscriptionCard org={org} />
              {(org.stripe_plan === PREMIUM_PER_REVISION_PLAN_NAME || hasBinaryDecomp) &&
              <BillingTermCard />}
              <ContributorCountCard org={org} setOrg={setOrg} />
              <ToggleInternalOrgCard />
            </Flex>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};
